// User statuses
export const STATUS_PENDING = "pending";
export const STATUS_ACTIVE = "active";
export const STATUS_INACTIVE = "inactive";
export const STATUS_BLOCKED = "blocked";
export const STATUS_REJECTED = "rejected";

// Job statuses
export const JOB_ACTIVE = "active";
export const JOB_COMPLETED = "completed";
export const JOB_CANCELLED = "cancelled";

// Attendance statuses
export const ATTENDANCE_PRESENT = "present";
export const ATTENDANCE_ABSENT = "absent";
export const ATTENDANCE_LATE = "late";
export const ATTENDANCE_EXCUSED = "excused";

// Entity statuses
export const ENTITY_ACTIVE = "active";
export const ENTITY_INACTIVE = "inactive";

// Agency statuses
export const AGENCY_ACTIVE = "active";
export const AGENCY_INACTIVE = "inactive";

// Job request statuses
export const JOB_REQUEST_PENDING = "pending";
export const JOB_REQUEST_APPROVED = "approved";
export const JOB_REQUEST_REJECTED = "rejected";
export const JOB_REQUEST_CONVERTED = "converted";
export const JOB_REQUEST_CANCELLED = "cancelled";

// Job request sources
export const JOB_REQUEST_SOURCE_PUBLIC = "public_form";
export const JOB_REQUEST_SOURCE_PORTAL = "entity_portal";

// Invoice statuses
export const INVOICE_DRAFT = "draft";
export const INVOICE_SENT = "sent";
export const INVOICE_PAID = "paid";
export const INVOICE_OVERDUE = "overdue";
export const INVOICE_CANCELLED = "cancelled";

// Payment methods
export const PAYMENT_INVOICE = "invoice";
export const PAYMENT_DIRECT = "direct"; // cash/check, no invoice needed

// Validation limits
export const MAX_PAY_RATE = 10000;
export const MAX_OFFICER_SLOTS = 999;
export const MAX_RECURRING_DAYS = 365;
export const MAX_TITLE_LENGTH = 200;
export const MAX_OFFICERS_PER_REQUEST = 100;

// Subscription statuses (placeholder for future billing)
export const SUB_TRIAL = "trial";
export const SUB_ACTIVE = "active";
export const SUB_PAST_DUE = "past_due";
export const SUB_CANCELLED = "cancelled";
